import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { LAYOUT_BOX, LAYOUT_HEADER, LAYOUT_SIDEBAR } from 'config/constants/ui'
import layoutBoxConstants from 'config/constants/protoThemeDefaults/layoutBox'
import layoutHeaderConstants from 'config/constants/protoThemeDefaults/layoutHeader'
import layoutSidebarConstants from 'config/constants/protoThemeDefaults/layoutSidebar'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import BoxLayout from '~/components/Layout/Box'
import HeaderLayout from '~/components/Layout/Header'
import SidebarLayout from '~/components/Layout/Sidebar'

const layouts = {
   [LAYOUT_BOX]: {
      component: BoxLayout,
      constants: layoutBoxConstants
   },
   [LAYOUT_HEADER]: {
      component: HeaderLayout,
      constants: layoutHeaderConstants
   },
   [LAYOUT_SIDEBAR]: {
      component: SidebarLayout,
      constants: layoutSidebarConstants
   }
}

const GlobalLayout = ({ children }) => {
   const location = useLocation()
   const { protoTheme: theme, setProtoTheme } = useContext(ProtoThemeContext)
   const currentLayout = theme.tmpGlobalLayout
   const LayoutComponent = layouts[currentLayout].component

   // Set theme constants for current layout
   useEffect(() => {
      setProtoTheme({
         ...theme,
         ...layouts[currentLayout].constants
      })
   }, [currentLayout])

   useEffect(() => {
      document.body.style.background = theme.tmpBackgroundColor
   }, [theme.tmpBackgroundColor])

   // TODO: Change how this works
   // For the following routes, render without Layout Container
   // as they are standalone views or takeover the screen
   // PR #757
   if (location.pathname.startsWith('/account') ||
      location.pathname.startsWith('/invitation') ||
      location.pathname.startsWith('/start')) {
      return children
   }

   return (
      <LayoutComponent>
         {children}
      </LayoutComponent>
   )
}

GlobalLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default GlobalLayout
